export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_20-1b18489cf6a657b40958119a12685214.jpg";